import { Navigate, Outlet, Route, Routes, useLocation } from "react-router-dom";
import { Aside } from "../../features/home/presentation/pages/Aside";
import { Column } from "../components/Column";
import { HomeScreen } from "../../features/home/presentation/pages/HomeScreen";
import { useEffect, useRef } from "react";
import { PlasticScreen } from "../../features/home/presentation/pages/PlasticScreen";
import sal from "sal.js";
import "sal.js/dist/sal.css";
import { MiningScreen } from "../../features/home/presentation/pages/MiningScreen";
import { AgroScreen } from "../../features/home/presentation/pages/AgroScreen";
import { PescaScreen } from "../../features/home/presentation/pages/PescaScreen";
import { SolutionScreen } from "../../features/home/presentation/pages/SolutionScreen";
import { Footer } from "../../features/home/presentation/pages/Footer";

export const AppRouter = () => {
	return (
		<Routes>
			<Route element={<Layout />}>
				<Route
					path="/"
					element={<HomeScreen />}
				/>
				<Route
					path="plastica"
					element={<PlasticScreen />}
				/>
				<Route
					path="minera"
					element={<MiningScreen />}
				/>
				<Route
					path="pesca"
					element={<PescaScreen />}
				/>
				<Route
					path="agroquimica"
					element={<AgroScreen />}
				/>
				<Route
					path="soluciones"
					element={<SolutionScreen />}
				/>
			</Route>
			<Route
				path="/*"
				element={<Navigate to="/" />}
			/>
		</Routes>
	);
};

const Layout: React.FC = () => {
	const location = useLocation();
	const mainRef = useRef<HTMLDivElement>(null);

	useEffect(() => {
		if (mainRef.current) mainRef.current.scrollTo({ top: 0 });
		sal({
			root: null,
			once: false,
			threshold: 0.1,
		});
	}, [location.pathname]);

	return (
		<Column
			ref={mainRef}
			className="bg-[#ffffff] overflow-y-auto  overflow-x-hidden relative max-h-svh"
		>
			<Aside />
			<main className="flex flex-col w-full min-h-screen text-gray-800">
				<Outlet />
				<Footer />
			</main>
		</Column>
	);
};
